export const it = {
  searchField: {
    retry: "Annulla",
  },
};
